export class FiltrosRepComercial{
   
   Usuario : string ='';
   Estado: string = '';
   Tipo: string = 'factura_negociada';

}